// NOVAPAY-116-RC3-R2 — staging-only QA hooks (never enabled on production hosts).
import { clearConsentPreferenceOnly } from "./customer-profile-v2.js";

const STAGING_HOST_SUFFIX = "staging.asiastyle-mini-app.pages.dev";

export function isStagingStoreV2Host(): boolean {
  try {
    if (typeof window === "undefined") return false;
    const host = window.location.hostname.toLowerCase();
    if (host === STAGING_HOST_SUFFIX || host.endsWith(`.${STAGING_HOST_SUFFIX}`)) return true;
    // Unique Pages deploy preview hosts for the same project.
    if (/^[a-f0-9]{8}\.asiastyle-mini-app\.pages\.dev$/i.test(host)) return true;
  } catch {
    /* ignore */
  }
  return false;
}

const STAGING_QA_CONSENT_RESET_SESSION_KEY = "store-v2-qa-consent-reset-v1";

export function clearStagingQaConsentResetSessionFlag(): void {
  try {
    window.sessionStorage.removeItem(STAGING_QA_CONSENT_RESET_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

export function wasStagingQaConsentResetThisSession(): boolean {
  try {
    return window.sessionStorage.getItem(STAGING_QA_CONSENT_RESET_SESSION_KEY) === "1";
  } catch {
    return false;
  }
}

/** Staging-only: `?qa_reset=consent` clears consent preference and strips the param. */
export function consumeStagingQaResetConsent(): boolean {
  if (!isStagingStoreV2Host()) return false;
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get("qa_reset") !== "consent") return false;
    clearConsentPreferenceOnly();
    window.sessionStorage.setItem(STAGING_QA_CONSENT_RESET_SESSION_KEY, "1");
    url.searchParams.delete("qa_reset");
    window.history.replaceState(window.history.state, "", `${url.pathname}${url.search}${url.hash}`);
    return true;
  } catch {
    return false;
  }
}

export function stagingQaResetConsentUrl(): string {
  const base = "https://staging.asiastyle-mini-app.pages.dev/staging-store-v2/";
  return `${base}?qa_reset=consent`;
}
